// Librairies importés.
import { DateHelper } from '@/shared/helpers/DateHelper';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

/**
 * Composant qui affiche la notification de déclaration POS manquante pour une ou plusieurs installations.
 */
@Component
export default class NotificationPosPopupComponent extends Vue {
    
    /**
     * Indique si la pop-up de notification est ouverte/visible.
     */
    public isOpen: boolean = true;

    /**
     * La date à afficher dans le message.
     */
    @Prop() public date: string;

    /**
     * Renvoie la date formatée pour le message.
     */
    public get dateFormatee(): string | undefined {
        const mois = Number(this.date.split('-')[1]);
        let prefix = 'de ';

        // Mois commençant par une voyelle.
        if (mois === 4 || mois === 8 || mois === 10) {
            prefix = 'd\''
        }
        return prefix + DateHelper.formatParam(this.date, 'MMMM YYYY');
    }
}
